import pkg from '../../../package.json';

function strToHex(str: string) {
  const result: string[] = [];
  for (let i = 0; i < str.length; ++i) {
    const hex = str.charCodeAt(i).toString(16);
    result.push(('000' + hex).slice(-4));
  }
  return result.join('').toUpperCase();
}

/**
 * Get the configuration file variable name
 */
const getVariableName = (title: string) =>
  `__PRODUCTION__${strToHex(title) || '__APP'}__CONF__`.replace(/\s/g, '');

const ENV_NAME = getVariableName(import.meta.env.VITE_GLOB_APP_TITLE);
const appEnv = import.meta.env.DEV ? import.meta.env : (window[ENV_NAME] as ImportMetaEnv);
const title = appEnv.VITE_GLOB_APP_TITLE;

export const globSetting = {
  title,
  logo: appEnv.VITE_GLOB_APP_LOGO,
  themeColor: appEnv.VITE_GLOB_THEME_COLOR,
  platform: appEnv.VITE_GLOB_APP_PLATFORM,
  device: appEnv.VITE_GLOB_APP_DEVICE,
  apiUrl: appEnv.VITE_GLOB_API_URL,
  shortName: title.replace(/\s/g, '_').replace(/-/g, '_'),
  urlPrefix: appEnv.VITE_GLOB_API_URL_PREFIX,
  uploadUrl: appEnv.VITE_GLOB_UPLOAD_URL,
};

export const VITE_PROXY = import.meta.env.VITE_PROXY;
export const IN_DEV = import.meta.env.DEV;
export const IN_PROD = import.meta.env.PROD;
export const envMode = import.meta.env.MODE;
export const commonStoragePrefix = `${globSetting.shortName}__${envMode.toUpperCase()}`;
export const storageShortName = `${commonStoragePrefix}${`__${pkg.version}`}__`;

export const IS_LOWCODE = globSetting.platform === 'LOWCODE';
export const IS_IMS = globSetting.platform === 'IMS';
export const PADMode = globSetting.device === 'PAD';
export const PCMode = globSetting.device === 'PC';
export const VERSION = pkg.version;
